export class StorageItem {
    constructor(
      public id: string,
      public name: string,
      public groupId: string,
      public groupName: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/shared/storage-items/shared/storage-item.model.ts